import { connect } from "react-redux";
import Active from "../../components/Segment/List/Active/Active";
import {
  fetchSegmentSummary,
  clearSegmentSummary,
  getSegmentCounts,
} from "../../actions/SegmentDetail";

import {
  getSegmentList,
  getSegmentWithRules,
  getAttributes,
  selectedSegment,
  recordActiveQueryParams,
  clearReactiveStatus,
} from "../../actions/SegmentList";
import { loadAttributes } from "../../actions/SegmentCreation";
import { selectClient } from "../../actions/App";

import { tail } from "lodash";

const mapStateToProps = state => {
  const { segment_summary, segment_counts } = state.segmentDetail;
  const {
    segment_list_active,
    archive_success,
    segment_attributes,
    active_segment_attributes,
    selectedSegmentSetArray,
  } = state.segmentList;
  const { categories } = state.segmentCreation;
  const { roleName, client_info, roleId, selected_client } = state.app;
  const demographic = categories ? tail(categories) : undefined;
  const geographic = categories ? categories[0] : undefined;

  let segment_detail = segment_summary;
  if (segment_detail) segment_detail.audiences = segment_counts;
  return {
    segment_summary: segment_detail,
    segment_list_active,
    archive_success,
    segment_attributes,
    geoAttributes: geographic,
    demoAttributes: demographic,
    selected_client: selected_client,
    segment_active_creation: state.segmentCreation,
    active_segment_attributes,
    roleName,
    roleId,
    client_info,
    selectedSegmentSetArray,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadAttributes: cid => {
      dispatch(loadAttributes(cid));
    },
    clearReactiveStatus: () => {
      dispatch(clearReactiveStatus());
    },
    getSegmentList: data => {
      dispatch(getSegmentList(data));
    },
    // archiveSegment: (id) => {
    //   dispatch(archiveSegment(id))
    // },
    fetchSegmentDetail: id => {
      dispatch(getSegmentCounts(id));
      dispatch(fetchSegmentSummary(id));
      dispatch(getAttributes(id));
    },
    clearSegmentSummary: () => {
      dispatch(clearSegmentSummary());
    },
    getSegmentWithRules: id => {
      dispatch(getSegmentWithRules(id));
    },
    selectClient: id => {
      dispatch(selectClient(id));
    },
    selectedSegment: setArray => {
      dispatch(selectedSegment(setArray));
    },
    recordActiveQueryParams: obj => {
      dispatch(recordActiveQueryParams(obj));
    },
  };
};

const SegmentActive = connect(mapStateToProps, mapDispatchToProps)(Active);

export default SegmentActive;



// WEBPACK FOOTER //
// ./src/containers/SegmentList/Active.js